import React from "react"
import { TickerMatch, TickerMatchState, TickerTeam } from "../../models"
import "./StreamSetScore.scss"
import { ReactComponent as SetBallIcon } from '../../images/ticker-icons/set-ball.svg';
import { BeachTickerMatch } from "../../beach/model";
import { SetPoints } from "../../../../../shared/reducers/game-state/match-sets/match-sets.reducer";
import { SetScore } from "../../../../../shared/reducers/game-state/match-sets/set-score/set-score.reducer";
import { BeachTickerMatchState } from "../../../../shared/beach/ticker";

interface Props {
  matchState: TickerMatchState | BeachTickerMatchState
  match: TickerMatch | BeachTickerMatch
  size?: string | null
}

export const StreamSetScore = React.memo((props: Props) => {

  const { matchState, match, size } = props
  const isSmall = size === 'small'
  const isShort = size === 'short'

  let setScore: SetScore
  let setPoints: SetPoints

  if (!matchState) {
    setPoints = { team1: 0, team2: 0 }
    setScore = { team1: 0, team2: 0 }
  } else {
    setPoints = matchState.setPoints
    const currentSet = matchState.matchSets[matchState.matchSets.length -1]
    setScore = currentSet.setScore
  }

  let isTeam1Serving = matchState?.serving === 'team1' ? true : false

  return <div className={"StreamSetScore" + (isSmall ? " small" : "") + (isShort ? " short" : "")}>
      <div className="TeamNames">
        <div className="TeamName">
          <div className="serving">{isTeam1Serving && <SetBallIcon></SetBallIcon>}</div>
          {match.team1 ? (isSmall ? (match.team1 as TickerTeam).clubCode : (isShort ? match.team1.shortName : match.team1.name)) : match.teamDescription1}
        </div>
        <div className="TeamName">
          <div className="serving">{!isTeam1Serving && <SetBallIcon></SetBallIcon>}</div>
          {match.team2 ? (isSmall ? (match.team2 as TickerTeam).clubCode : (isShort ? match.team2.shortName : match.team2.name)) : match.teamDescription2} 
        </div>
      </div>
      <div className="ScoreContainer">
        <div className="Scores">
          <div className="Score">
            {setPoints.team1}
          </div>
          <div className="Score">
            {setPoints.team2}
          </div>
        </div>
        <div className="Scores">
          <div className="Score">
            {setScore.team1}
          </div>
          <div className="Score">
            {setScore.team2}
          </div>
        </div>
      </div>
    </div>
})
